import { BANNER_VARIANT_ICONS } from './constants';
import { Banner } from './Banner';
import { BannerProps, BannerVariants } from './types';

export { Banner, BANNER_VARIANT_ICONS };

export const InfoBanner = (props: BannerProps) => (
  <Banner
    variant={BannerVariants.INFO}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.INFO]}
    {...props}
  />
);
export const SubtleInfoBanner = (props: BannerProps) => (
  <Banner
    isSubtle
    variant={BannerVariants.INFO}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.INFO]}
    {...props}
  />
);
export const NeutralBanner = (props: BannerProps) => (
  <Banner
    variant={BannerVariants.NEUTRAL}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.INFO]}
    {...props}
  />
);
export const SubtleNeutralBanner = (props: BannerProps) => (
  <Banner
    isSubtle
    variant={BannerVariants.NEUTRAL}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.INFO]}
    {...props}
  />
);
export const SuccessBanner = (props: BannerProps) => (
  <Banner
    variant={BannerVariants.SUCCESS}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.SUCCESS]}
    {...props}
  />
);
export const SubtleSuccessBanner = (props: BannerProps) => (
  <Banner
    isSubtle
    variant={BannerVariants.SUCCESS}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.SUCCESS]}
    {...props}
  />
);
export const WarningBanner = (props: BannerProps) => (
  <Banner
    variant={BannerVariants.WARNING}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.WARNING]}
    {...props}
  />
);
export const SubtleWarningBanner = (props: BannerProps) => (
  <Banner
    isSubtle
    variant={BannerVariants.WARNING}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.WARNING]}
    {...props}
  />
);
export const ErrorBanner = (props: BannerProps) => (
  <Banner
    variant={BannerVariants.ERROR}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.ERROR]}
    {...props}
  />
);
export const SubtleErrorBanner = (props: BannerProps) => (
  <Banner
    isSubtle
    variant={BannerVariants.ERROR}
    Icon={BANNER_VARIANT_ICONS[BannerVariants.ERROR]}
    {...props}
  />
);
